import {
  Location,
  LocationStrategy,
  PathLocationStrategy
} from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { CommonService, SiteService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-peak-demand-report',
  templateUrl: './peak-demand-report.component.html',
  styleUrls: ['./peak-demand-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: Constants.DATE_RANGES_PROVIDER_FORMAT
    },
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ]
})

/**
 *
 *
 * @export
 * @class PeakDemandReportComponent
 * @implements {OnInit}
 */
export class PeakDemandReportComponent implements OnInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  displayAllSiteID: boolean;
  formPeakDemand: UntypedFormGroup;
  siteId: string;
  sites: any;
  selectedSite: string;
  max = new Date();
  dateBound: number = 10;
  startDateCtr = new UntypedFormControl(moment());
  endDateCtr = new UntypedFormControl(moment());
  isValidStartDate = true;
  startDateErrorMessage: String;
  isValidEndDate = true;
  endDateErrorMessage: String;

  /**
   * Creates an instance of PeakDemandReportComponent.
   * @param {FormBuilder} fb
   * @param {SiteService} siteService
   * @param {CommonService} commonService
   * @param {DataService} dataService
   * @param {AlertService} alertService
   * @memberof PeakDemandReportComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    private siteService: SiteService,
    private commonService: CommonService,
    private dataService: DataService,
    private alertService: AlertService,
    private location: Location
  ) {
    this.formPeakDemand = this.fb.group({
      siteCtr: ['', [Validators.required]],
      startDateCtr: [''],
      endDateCtr: ['']
    });
  }

  /**
   * ngOnInit function checking for SiteId
   *
   * @memberof PeakDemandReportComponent
   */
  ngOnInit() {
    this.getSiteDetails();
    this.formPeakDemand.reset();
    this.siteId = localStorage.getItem('siteId');

    //Check for access to multiple sites
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
      this.formPeakDemand.get('siteCtr').clearValidators();
      console.log(this.siteId);
    } else {
      this.displayAllSiteID = true;
    }
    console.log(this.siteId);
  }

  /**
   * Function to get list of Sites
   *
   * @memberof PeakDemandReportComponent
   */
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe((data) => {
      this.sites = data;
    });
  }

  /**
   * Function call to check validations for Start Date
   *
   * @memberof PeakDemandReportComponent
   */
  validateStartDate() {
    var modelData = this.commonService.validateStartDate(
      this.dateBound,
      this.startDateCtr,
      this.endDateCtr,
      this.isValidStartDate,
      this.isValidEndDate,
      this.startDateErrorMessage,
      this.endDateErrorMessage
    );
    this.startDateCtr = modelData.startDateCtr;
    this.endDateCtr = modelData.endDateCtr;
    this.isValidEndDate = modelData.isValidEndDate;
    this.isValidStartDate = modelData.isValidStartDate;
    this.startDateErrorMessage = modelData.startDateErrorMessage;
    this.endDateErrorMessage = modelData.endDateErrorMessage;
  }

  /**
   * Function call to check validations for End Date
   *
   * @memberof PeakDemandReportComponent
   */
  validateEndDate() {
    var modelData = this.commonService.validateEndDate(
      this.dateBound,
      this.startDateCtr,
      this.endDateCtr,
      this.isValidStartDate,
      this.isValidEndDate,
      this.startDateErrorMessage,
      this.endDateErrorMessage
    );
    this.startDateCtr = modelData.startDateCtr;
    this.endDateCtr = modelData.endDateCtr;
    this.isValidEndDate = modelData.isValidEndDate;
    this.isValidStartDate = modelData.isValidStartDate;
    this.startDateErrorMessage = modelData.startDateErrorMessage;
    this.endDateErrorMessage = modelData.endDateErrorMessage;
  }

  /**
   * Function call on change of year in start datepicker
   *
   * @param {Moment} normalizedYear
   * @memberof PeakDemandReportComponent
   */
  chosenStartDate_YearHandler(normalizedYear: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of month in start datepicker
   *
   * @param {Moment} normalizedMonth
   * @memberof PeakDemandReportComponent
   */
  chosenStartDate_MonthHandler(normalizedMonth: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of year in End datepicker
   *
   * @param {Moment} normalizedYear
   * @memberof PeakDemandReportComponent
   */
  chosenEndDate_YearHandler(normalizedYear: Moment) {
    const ctrlValue = this.endDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.endDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of month in End datepicker
   *
   * @param {Moment} normalizedMonth
   * @memberof PeakDemandReportComponent
   */
  chosenEndDate_MonthHandler(normalizedMonth: Moment) {
    const ctrlValue = this.endDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDateCtr.setValue(ctrlValue);
  }

  /**
   * Function to show field errors for form
   *
   * @param {string} fieldName
   * @param {string} errorCode
   * @memberof PeakDemandReportComponent
   */
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formPeakDemand.get(fieldName).hasError(errorCode);
  };

  /**
   * Function call happen when user clicks submit button with buttonId submitPeakDemandForm
   *
   * @memberof PeakDemandReportComponent
   */
  submitPeakDemandForm() {
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    let url = '';
    //Change value of Date into String
    var fromDate = this.commonService.transform(this.startDateCtr);
    var toDate = this.commonService.transform(this.endDateCtr);

    //API call to get export Peak Demand Report url
    url = this.commonService.getPeakDemandExportUrl(
      this.siteId,
      fromDate,
      toDate
    );

    // API to generate excel
    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      } else {
        this.alertService.message = 'No Data present for selected duration';
        this.alertService.showError();
      }
    });
  }

  /**
   * Function to Reset all form fields to its initial state
   *
   * @param {*} event
   * @memberof PeakDemandReportComponent
   */
  public reset = (event: any) => {
    event.preventDefault();
    this.formDirective.resetForm();
    this.formPeakDemand.reset();
    this.startDateCtr = new UntypedFormControl(moment());
    this.endDateCtr = new UntypedFormControl(moment());
  };
  //goToBack() redirect to last visited page location
  goToBack() {
    this.location.back();
  }
}
